import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KNZUtilModule } from '@knz/util';

import { QRComponent } from './qr.component';

const COMPONENTS = [QRComponent];

@NgModule({
  imports: [CommonModule, KNZUtilModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class QRModule {}
